import { ReactNode } from 'react';
import { ErrorBoundary as ErrorBoundaryBase } from 'react-error-boundary';
import { useLocation } from 'react-router-dom';
import GeneralError from '../GeneralError';

/**
 * 子孫コンポーネントでエラーが発生したとき汎用エラー画面を表示する
 *
 * エラーはパスが変わったときにクリアされる。
 */
function ErrorBoundary({ children }: { children?: ReactNode }) {
  const location = useLocation();
  return (
    <ErrorBoundaryBase FallbackComponent={GeneralError} key={location.pathname}>
      {children}
    </ErrorBoundaryBase>
  );
}

export default ErrorBoundary;
